// extracted by mini-css-extract-plugin
export default {"content":"ComboCampaignProductList_content__AbnZX"};